'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

interface StickyQuoteCTAProps {
  className?: string;
}

const StickyQuoteCTA = ({ className = '' }: StickyQuoteCTAProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentMessage, setCurrentMessage] = useState('Get Factory Pricing');
  const [isExpanded, setIsExpanded] = useState(false);

  const messages = {
    default: 'Get Factory Pricing',
    solutions: 'Customize Your Screen',
    calculator: 'Calculate Savings Now',
    quality: 'Request Quality Report',
    stories: 'Start Your Success Story',
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY;
      setIsVisible(scrolled > 300);

      const sections = Object.keys(messages).filter(key => key !== 'default');
      let activeMessage = messages.default;

      for (const sectionId of sections) {
        const element = document.getElementById(sectionId);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= 200 && rect.bottom >= 200) {
            activeMessage = messages[sectionId as keyof typeof messages];
            break;
          }
        }
      }

      setCurrentMessage(activeMessage);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = () => {
    const quoteSection = document.querySelector('#quote');
    if (quoteSection) {
      const offset = 80;
      const elementPosition = quoteSection.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: elementPosition - offset,
        behavior: 'smooth'
      });
    }
  };

  if (!isVisible) return null;

  return (
    <>
      <button
        onClick={handleClick}
        onMouseEnter={() => setIsExpanded(true)}
        onMouseLeave={() => setIsExpanded(false)}
        className={`fixed bottom-6 right-6 z-[1100] bg-accent text-accent-foreground rounded-full shadow-cta hover:shadow-lg transition-all duration-300 ease-out md:hidden ${className}`}
        aria-label="Get quote"
      >
        <div className="flex items-center justify-center w-14 h-14">
          <Icon name="DocumentTextIcon" size={24} variant="outline" />
        </div>
      </button>

      <button
        onClick={handleClick}
        onMouseEnter={() => setIsExpanded(true)}
        onMouseLeave={() => setIsExpanded(false)}
        className={`hidden md:flex fixed bottom-8 right-8 z-[1100] items-center gap-3 bg-accent text-accent-foreground rounded-full shadow-cta hover:shadow-lg transition-all duration-300 ease-out ${
          isExpanded ? 'px-6 py-4' : 'px-4 py-4'
        } ${className}`}
      >
        <Icon name="DocumentTextIcon" size={24} variant="outline" />
        <span
          className={`font-headline font-semibold text-base whitespace-nowrap overflow-hidden transition-all duration-300 ${
            isExpanded ? 'max-w-xs opacity-100' : 'max-w-0 opacity-0'
          }`}
        >
          {currentMessage}
        </span>
      </button>
    </>
  );
};

export default StickyQuoteCTA;